// src/tableConfigs/InvoiceColumns.js
import React, { useState } from "react";
import { Button, Space, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import api from "../utils/api";

export const useInvoiceColumns = () => {
  const [buttonLoading, setButtonLoading] = useState({});

  // Return a FUNCTION that accepts refresh, instead of the array directly
  const getColumns = (refreshTable) => {
    const handleAction = async (record, isPaidAction) => {
      try {
        if (!record?.id) return message.error("Invalid ID ❌");
        const typeKey = isPaidAction ? 'paid' : 'unpaid';
        setButtonLoading(prev => ({ ...prev, [record.id]: { ...prev[record.id], [typeKey]: true } }));

        const formData = new FormData();

        // 2. Append your variables as fields
        formData.append("id", record.id);
        formData.append("isPaid", isPaidAction);

        // 3. Send via Axios matching your invoice layout configuration
        const response = await api.post("/crm/generatePdf", formData, {
          responseType: "blob",
          headers: {
            "Content-Type": "multipart/form-data", // Allows Axios to set boundaries smoothly
          },
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        window.open(fileURL, "_blank");
        message.success(isPaidAction ? "Invoice marked as Paid ✅" : "Invoice downloaded ✅");

        if (refreshTable) await refreshTable();
      } catch (error) {
        console.error("Action error:", error);
        message.error("Failed to process request ❌");
      } finally {
        const typeKey = isPaidAction ? 'paid' : 'unpaid';
        setButtonLoading(prev => ({ ...prev, [record.id]: { ...prev[record.id], [typeKey]: false } }));
      }
    };

    return [
      { title: "Invoice No", dataIndex: "id", sorter: true, width: 120 },
      { title: "Buyer Name", dataIndex: "buyerName", sorter: true },
      { title: "Email", dataIndex: "buyerEmail" },
      { title: "Issue Date", dataIndex: "issueDate", sorter: true },
      {
        title: "Actions",
        key: "actions",
        render: (_, record) => (
          <Space>
            <Button
              type={record.isPaid ? "default" : "primary"}
              icon={<DownloadOutlined />}
              style={{ backgroundColor: record.isPaid ? "grey" : "green", color: "white", border: "none" }}
              onClick={() => handleAction(record, true)}
              loading={buttonLoading[record.id]?.paid}
            >
              {record.isPaid ? "Paid" : "Pay"}
            </Button>
            <Button
              icon={<DownloadOutlined />}
              onClick={() => handleAction(record, false)}
              loading={buttonLoading[record.id]?.unpaid}
            >
              Unpaid
            </Button>
          </Space>
        ),
      },
    ];
  };

  return getColumns; // Return the function, not the array
};